var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"chartCanvas",style:({ width: '100%', height: '150px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }